// extracted by mini-css-extract-plugin
var _1 = "EmailProfileMessageHeaderSenderAdditionalInfoTo-moduleEmailProfileMessageHeaderSenderAdditionalInfoTo__MrovS";
var _2 = "EmailProfileMessageHeaderSenderAdditionalInfoTo-moduledropdown__bJ2gg ScrollContainer-moduleScrollContainer__LHyVB";
var _3 = "EmailProfileMessageHeaderSenderAdditionalInfoTo-moduleicon__KSEjW";
var _4 = "EmailProfileMessageHeaderSenderAdditionalInfoTo-modulelabel__Yifrk";
var _5 = "EmailProfileMessageHeaderSenderAdditionalInfoTo-modulerow__q5g0Z";
var _6 = "EmailProfileMessageHeaderSenderAdditionalInfoTo-moduletoButton__W6AUt";
var _7 = "EmailProfileMessageHeaderSenderAdditionalInfoTo-moduletoLabel__KxiOI";
var _8 = "EmailProfileMessageHeaderSenderAdditionalInfoTo-modulevalue__GKF33";
var _9 = "EmailProfileMessageHeaderSenderAdditionalInfoTo-modulevalues__r0YjU";
export { _1 as "EmailProfileMessageHeaderSenderAdditionalInfoTo", _2 as "dropdown", _3 as "icon", _4 as "label", _5 as "row", _6 as "toButton", _7 as "toLabel", _8 as "value", _9 as "values" }
